import { IAnimationControllerConfiguration, Inject, SimpleBaseController, SoundType } from '@denishussar/html5-game-engine';
import { GameModel, GamePlayerTypeEnum } from '../../Models/GameModel';
import { SoundModel } from '../../Models/SoundModel';
import { Sounds } from '../../Constants/Sounds';
import { ISpineControllerOptions, SpineAnimationBaseController } from '../Common/SpineAnimationBaseController';
import { Graphics, Rectangle } from 'pixi.js';
import { AnimateCarController } from './AnimateCarController';

export interface IGameCarControllerOptions {
    type: GamePlayerTypeEnum
}

enum spineAnimations {
    idle = "go_idle",
    idleBlick = "go_idle_blick",
    acceleration = "go_start",
    turnLeft = "turn_left",
    turnRight = "turn_right",
    left2idle = "from_right_to_idle",
    right2idle = "from_left_to_idle",
    stop = "go_stop",
}

enum stateEnum {
    none,
    forward,
    accelerating,
    left,
    right,
}

const colors = ['green', 'red', 'blue', 'fuchsia'];
const cars = ['car_vaz', 'car_delorian', 'car_impala', 'car_countach'];
export class GamePlayerController extends SimpleBaseController {
    $model: GameModel;
    public spineCar: SpineAnimationBaseController | null;
    public psevdoCar: AnimateCarController | null;
    public bounds: Rectangle;
    private driveSound = "";
    private currentAnimation: null | spineAnimations;
    private lastAnimation: null | spineAnimations;
    private state = stateEnum.none;
    private debug: Graphics
    public constructor(
        @Inject private _options: IGameCarControllerOptions,
        @Inject private soundLevels: SoundModel,
    ) {
        super('GameCarController');
    }

    public updateBounds() {
        this.bounds = this.psevdoCar.display.getBounds();
        // this.debug.clear();
        // this.debug.beginFill(0xffffff, 0.5);
        // this.debug.drawRect(this.bounds.x, this.bounds.y, this.bounds.width, this.bounds.height);
        // this.debug.endFill();
    }



    protected getConfiguration(): IAnimationControllerConfiguration {
        this.setSounds();
        const children = {};

        children["car"] = {
            controller: SpineAnimationBaseController,
            model: this.$model,
            options: {
                key: "car_spine",
                url: `/images/spine/${cars[this.$model.garage_selectedCar]}/${cars[this.$model.garage_selectedCar]}_${colors[this.$model.currentPlayer.paint]}.json`,
                animations: Object.values(spineAnimations),
            } as ISpineControllerOptions,
        };
        children["psevdo"] = {
            controller: AnimateCarController,
            model: this.$model,
            options: this._options,
        }
        // this.debug = new Graphics(true);
        // this.renderer.stage.addChild(this.debug);



        return <IAnimationControllerConfiguration>{
            sounds: [
                {
                    id: this.driveSound,
                    type: SoundType.SFX,
                },
                {
                    id: Sounds.ACCELERATION_1,
                    type: SoundType.SFX,
                },
                {
                    id: Sounds.SWAP_LINE,
                    type: SoundType.SFX,
                },
            ],
            childControllers: children,
            modelWatch: {
                playerSpeed: (speed: number) => {
                    if (speed < this.$model.playerSpeedMax) {
                        if (speed === 0) {
                            this.soundManager.stop(this.driveSound);
                            this.setAnimation(spineAnimations.stop);
                            return;
                        }
                        else {
                            this.changeState(stateEnum.accelerating);
                            if (!this.soundManager.isSoundPlaying(Sounds.ACCELERATION_1)) {
                                this.soundManager.play(Sounds.ACCELERATION_1, false, this.soundLevels.carVolume);
                                setTimeout(() => {
                                    this.soundManager.play(this.driveSound, true, this.soundLevels.carVolume * speed / this.$model.playerSpeedMax);
                                }, 800);
                            }
                            this.soundManager.changeVolume(this.driveSound, this.soundLevels.carVolume * speed / this.$model.playerSpeedMax);
                            return;
                        }
                    }
                    else {
                        if (!this.soundManager.isSoundPlaying(this.driveSound))
                            this.soundManager.play(this.driveSound, true, this.soundLevels.carVolume);
                        else
                            this.soundManager.changeVolume(this.driveSound, this.soundLevels.carVolume);
                        return;
                    }
                },
                playerRoadIndex: (index: number, oldIndex) => {
                    this.soundManager.play(Sounds.SWAP_LINE, false, this.soundLevels.carVolume);
                    this.setDirection(index - oldIndex);
                },

            }
        };
    }

    protected onDestroy(){
        this.spineCar = null;
        this.psevdoCar = null;
        // this.debug.parent.removeChild(this.debug);
        // this.debug.destroy();
    }

    protected onInitialize(): void {

        this.spineCar = this.$childControllers.get("car");
        this.psevdoCar = this.$childControllers.get("psevdo");
        if (this.spineCar)
            this.psevdoCar.visible = false;
        this.setDirection(0);
        this.display.scale.set(3 * GameModel.SCALE);

        // this.spineCar.setAnimation(spineAnimations.idle, false);
        if (this.spineCar)
            this.spineCar.getSpine().state.addListener({
                complete: track => this.animationListener(track),
            })

        this.changeState(stateEnum.forward);
        if(this._options.type == GamePlayerTypeEnum.vaz){
            const car = this.$childControllers.get("psevdo") as AnimateCarController;
            car.scaleX = car.scaleY = 0.8;
        }
    }

    private setSounds() {
        switch (this._options.type) {
            case GamePlayerTypeEnum.vaz:
                this.driveSound = Sounds.DRIVE_1;
                break;
            case GamePlayerTypeEnum.delorean:
                this.driveSound = Sounds.DRIVE_2;
                break;
            case GamePlayerTypeEnum.lamborgini:
                this.driveSound = Sounds.DRIVE_3;
                break;
            case GamePlayerTypeEnum.ferrari:
                this.driveSound = Sounds.DRIVE_4;
                break;
        }


    }

    private animationListener(track: PIXI.spine.core.TrackEntry) {
        if (this.currentAnimation)
            this.lastAnimation = this.currentAnimation;
        this.currentAnimation = null;
        this.animationConveyor();
    }

    onUpdate() {
        this.checkSounds();
    }

    protected checkSounds() {

    }

    protected onResize(width: number, height: number, scale: number) {
    }

    private animationConveyor() {
        if (this.lastAnimation == spineAnimations.acceleration) {
            this.setAnimation(spineAnimations.idle, false);
        }
    }

    private setAnimation(name: spineAnimations, loop: boolean = false) {
        if (this.currentAnimation)
            this.lastAnimation = this.currentAnimation;
        this.currentAnimation = name;
        this.spineCar.setAnimation(name, loop);
    }

    private changeState(s: stateEnum) {
        if (this.spineCar)
            if (s != this.state)
                switch (s) {
                    case stateEnum.forward:
                        switch (this.state) {
                            case stateEnum.left:
                                this.setAnimation(spineAnimations.left2idle);
                                break;
                            case stateEnum.right:
                                this.setAnimation(spineAnimations.right2idle);
                                break;
                            case stateEnum.accelerating:
                                if (this.$model.playerSpeed !== this.$model.playerSpeedMax) {
                                    return;
                                }
                            default:
                                this.setAnimation(spineAnimations.idle);

                        }
                        break;
                    case stateEnum.left:
                        this.setAnimation(spineAnimations.turnLeft);
                        break;
                    case stateEnum.right:
                        this.setAnimation(spineAnimations.turnRight);
                        break;
                    case stateEnum.accelerating:
                        this.setAnimation(spineAnimations.acceleration);
                        break;
                }
        this.state = s;
    }


    public setDirection(dir: number): void {
        // this.spineCar.setAnimation(spineAnimations.idle, false);

        if (this.psevdoCar)
            this.psevdoCar.setDirection(dir);

        switch (dir) {
            case -1:
                this.changeState(stateEnum.left);
                break;
            case 0:
                this.changeState(stateEnum.forward);
                break;
            case 1:
                this.changeState(stateEnum.right);
                break;
        }
    }


}
